import { Granularity } from 'types/contracts.ts'
import { GranularityNavigationInputs, NavigationItemType } from './types.ts'
import { DatePickerNativeProps } from '@boltenergy-be/design-system'
import { OpUnitType } from 'dayjs'

export const GRANULARITY_DAYJS_END_OF: { [key in Granularity]: OpUnitType } = {
  [Granularity.QUARTER_HOUR]: 'day',
  [Granularity.HOUR]: 'day',
  [Granularity.DAY]: 'month',
  [Granularity.MONTH]: 'year'
}

export const DATE_INPUT_TYPE: Record<GranularityNavigationInputs['view'], DatePickerNativeProps['type'] | undefined> = {
  [Granularity.QUARTER_HOUR]: 'date',
  [Granularity.HOUR]: 'date',
  [Granularity.DAY]: 'month',
  [Granularity.MONTH]: undefined,
  [NavigationItemType.CYCLE]: undefined
}
